if($('.video-slide-swipe').length){
  hp.swipers = hp.swipers || {};
  var video_slide_swipe = 
  {
    initialized: false
  };
  hp.videoRay = {};
  
  video_slide_swipe.init = function(){
    var videoSlideProps = {
      pagination: {
        el: '.video-slide-module-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.right-arrow-video1',
        prevEl: '.left-arrow-video1',
      },
      lazy: false,
      slidesPerView: 1.5,
      spaceBetween: 20,
      //loop: true,
      breakpoints: {
        1200: {
          slidesPerView: 1.3,
          spaceBetween: 20
        },
        1000: {
          slidesPerView: 1.25,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 1.2,
          spaceBetween: 20
        },
        800: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 16
        }
      }
    }
    var videoSlideMethods = {
      resizeHandler: true,
      a11ySwiper: true
    }

    if($(".videoSlideModule .card-module-wrapper.videoVersion").length && $(window).width() > 767){
      var offsetAfter = $("#videoSlideModule .swiper-wrapper .swiper-slide").width() / 2;
      videoSlideProps.slidesOffsetAfter = offsetAfter;
    }

    video_slide_swipe.instances = hp.swiperInstance('.video-slide-swipe', videoSlideProps, videoSlideMethods, propsModifier);
    video_slide_swipe.initialized = true;
    

    
    // youtube iframe gets focus we move to that slide
    window.addEventListener('blur',function(){
      if(document.activeElement.className === 'video-iframe'){
        var $par = $(document.activeElement.parentNode.parentNode)
        if(video_slide_swipe.instances.length > 1){
          video_slide_swipe.instances[$(document.activeElement).parents('.video-slide-swipe').data('id')].slideTo($par.index());        
        }else{
          video_slide_swipe.instances.slideTo($par.index());        
        }
      } 
    });
    
    // placeholder play button gets focus we move to that slide
    $(".video-slide-swipe .swiper-slide>div>a").on('focus', function(){
      hp.stopOtherVids();
      var $par = $(this).parent().parent()
      $par.addClass('color_ff')// show white focus outline
      // videoSlide.slideTo($par.index())
      video_slide_swipe.instances[parseInt($(this).parents('.video-slide-swipe').data('id'))].slideTo($par.index())
    })

    // placeholder play button gets click or keyup we load youtube video
    $(".video-slide-swipe .swiper-slide>div>a").on('click keyup', function(event){
      event.preventDefault();
      event.stopPropagation();
      if([1,13].indexOf(event.which)<0){
        return false;
      }
      var $thisContainer = $(this).parents('.card-module-container'),
          left = $(this).offset().left,
          compare = $thisContainer.offset().left + $thisContainer.width()-50;
          
      if(left > compare){return}
      
      var videoId = $(this).next().attr('data-video-id'),
          iframeId;
      $('.video-iframe[data-video-id='+videoId+']').each(function(i,x){
        iframeId = videoId+'_'+i;
        $(x).attr('id',iframeId).show().prev().css('display','none').parent().addClass('fade-to-black');
        initializePlayer(videoId,iframeId);
      })
    });
    
    // stop other vids and update pagination if slide changes
    if(video_slide_swipe.instances.length > 1){
      for(var i = 0; i < video_slide_swipe.instances.length; i++){
        $('.new-pagination-type-variation-2', $(video_slide_swipe.instances[i].$el)).addClass('new-pagination-type-variation-2-'+$(video_slide_swipe.instances[i].$el).data('id'))
        video_slide_swipe.instances[i].on('slideChangeTransitionStart', function () {
          hp.stopOtherVids()
          // last slide does not slide all the way left so this is minor hack to fix issue with pagination
          showHideArrows(this);
          var arrowLeftVis = this.activeIndex == 0 ? 'hidden' : 'visible',
              arrowRightVis = this.activeIndex == this.slides.length-1 ? 'hidden' : 'visible';
          $('.new-pagination-type-variation-2-'+$(this.$el).data('id')).html(this.activeIndex+1)
          $(this.navigation.$prevEl).css('visibility',arrowLeftVis)
          $(this.navigation.$nextEl).css('visibility',arrowRightVis)
        });
      }   
    }else{
      video_slide_swipe.instances.on('slideChangeTransitionStart', function () {
        hp.stopOtherVids()
        // last slide does not slide all the way left so this is minor hack to fix issue with pagination
        showHideArrows(this); 
        var arrowLeftVis = this.activeIndex == 0 ? 'hidden' : 'visible',
            arrowRightVis = this.activeIndex == this.slides.length-1 ? 'hidden' : 'visible';
        $('.new-pagination-type-variation-2').html(this.activeIndex+1)
        $('.left-arrow-video1').css('visibility',arrowLeftVis)
        $('.right-arrow-video1').css('visibility',arrowRightVis)
      });
    }
  }//END init

  function showHideArrows(swiper){    
    if(swiper.prevIndex === swiper.activeIndex){
      swiper.activeIndex += 1;
    }
    if(swiper.slides.length - 1 === swiper.activeIndex){
      swiper.allowSlideNext = false;
    }else if(!swiper.allowSlideNext){
      swiper.allowSlideNext = true;
    }
    if(swiper.activeIndex === 0){
      swiper.allowSlidePrev = false;
    }else if(!swiper.allowSlidePrev){
      swiper.allowSlidePrev = true;
    }
    swiper.prevIndex = swiper.activeIndex
  }

  function onPlayerReady(event){
    //console.log('onPlayerReady',event.target)
    //event.target.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
  }
  function onPlayerStateChange(event){
    //console.log('onPlayerStateChange',event.target.a.id)
    event.data === 1 && hp.stopOtherVids(event.target.a.id);
  }
  function initializePlayer(videoId,iframeId){
    //console.log('initializePlayer - videoRay[videoId]',videoId,videoRay[videoId])
    if(window.YT.loaded){
      // console.log('YT loaded',iframeId)
      hp.stopOtherVids(iframeId)
      hp.videoRay[iframeId] = new YT.Player(iframeId, {
        videoId: videoId,
        playerVars: { 'autoplay': 1, 'rel': 0, showinfo: 0 },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      });
    }else{
      // console.log('YT NOT loaded');
      setTimeout(function(){
        initializePlayer(videoId,iframeId)
      },100);
    }
    //console.log('initializePlayer - videoRay[videoId]2',videoId,videoRay[videoId])
  }

  //the propsModifier function is used to modify the props for each instance of the multiple swiper individually
  function propsModifier(swiper, props){
    if($(window).width() > 767){
      var offsetAfter = $(swiper).find(".swiper-wrapper .swiper-slide").width() / 2;
      var modifiedProps = JSON.parse(JSON.stringify(props));
      modifiedProps.slidesOffsetAfter = offsetAfter;
      return modifiedProps;
    }else{
      return props; 
    }
  }

  hp.swipers.video_slide_swipe = video_slide_swipe;
}
